module.exports = __webpack_public_path__ + "img/bg.53267802.png";